import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { boolean } from "../../shared/src/codecs/types/boolean";
import { intersection } from "../../shared/src/codecs/types/intersection";
import { literal } from "../../shared/src/codecs/types/literal";
import { overload } from "../../shared/src/codecs/types/overload";
import { required } from "../../shared/src/codecs/types/required";
import { requiredFlatOverloaded } from "../../shared/src/codecs/types/requiredFlatOverloaded";
import { union } from "../../shared/src/codecs/types/union";
import { SellingPropertyState } from "./SellingPropertyState";
import { PaymentMethod } from "./PaymentMethod";

import { HasProvidedConveyancerDetails } from "./HasProvidedConveyancerDetails";
import { HasProvidedProofOfFundsForOffer } from "./HasProvidedProofOfFundsForOffer";
import { HasProvidedMortgageBrokerDetails } from "./HasProvidedMortgageBrokerDetails";
import { calculateSpeedPoints, speedFromPoints } from "../models/ScoringPoints";

const EstimatedTimeToCompletion1 = union([literal("fast"), literal("medium"), literal("slow")]);

export type TEstimatedTimeToCompletion1 = TTypeOfCodec<typeof EstimatedTimeToCompletion1>;

export const EstimatedTimeToCompletion2 = overload(
    EstimatedTimeToCompletion1,
    intersection([
        required({
            selling_property_state: SellingPropertyState,
            conveyancer_confirmed_timeframe: boolean(),
            payment_method: PaymentMethod,
            mortgage_broker_has_vouched: boolean(),
        }),
        requiredFlatOverloaded({
            has_provided_conveyancer_details: HasProvidedConveyancerDetails,
            has_provided_proof_of_funds: HasProvidedProofOfFundsForOffer,
            has_provided_mortgage_broker_details: HasProvidedMortgageBrokerDetails,
        }),
    ]),
    (details) => speedFromPoints(calculateSpeedPoints({
        has_provided_conveyancer_details: details.has_provided_conveyancer_details,
        conveyancer_confirmed_timeframe: details.conveyancer_confirmed_timeframe,
        selling_property_state: details.selling_property_state,
        has_provided_proof_of_funds: details.has_provided_proof_of_funds,
        payment_method: details.payment_method,
        mortgage_broker_has_vouched: details.mortgage_broker_has_vouched,
        has_provided_mortgage_broker_details: details.has_provided_mortgage_broker_details,
    })),
);
